export default __webpack_public_path__ + "static/media/P9.5de576b6.png";